import axiosInstance from './axiosInstance';

// Create a new employee
export const createEmployee = (data) => axiosInstance.post('/employees', data);

// Get all employees
export const getEmployees = () => axiosInstance.get('/employees');

// Get a single employee by ID
export const getEmployeeById = (id) => axiosInstance.get(`/employees/${id}`);

// Update an employee by ID
export const updateEmployee = (id, data) =>
	axiosInstance.put(`/employees/${id}`, data);

// Update employee profile image
export const updateEmployeeProfileImage = (id, profileImage) =>
	axiosInstance.put(`/employees/${id}/profileImage`, { profileImage });

// Delete an employee by ID
export const deleteEmployee = (id) => axiosInstance.delete(`/employees/${id}`);

// Resend password for an employee
export const resendEmployeePassword = (id) =>
	axiosInstance.post(`/employees/${id}/resend-password`);
